import React from 'react';
import {
  Box,
  Typography,
  Button,
  Chip,
  useMediaQuery,
  createTheme,
  IconButton
} from '@mui/material';
import ReactPlayer from 'react-player' // react video player
import determineFileType from 'src/screens/Partners/Courses/hook/checkfileType';
import { makeStyles } from '@mui/styles';
import { ArrowForward, StarBorder, ArrowBack, BookmarkBorder } from '@mui/icons-material';
import useServiceCard from '../../shared/logic/useServiceCard';
import { Rating } from '@mui/material';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad'
import { useCompanyData } from '../../shared/contexts/DataContext';
import NoImage from 'src/assets/images/no-pictures.png';
import { extractContent } from '../../shared/logic/Utils';

const theme = createTheme();
const useStyles = makeStyles(() => ({
  readMore:{
    transition:'6s',
    backgroundColor:'transparent !important',
    "&:hover":{
      color:"#fac400"
    }
  },

  mainComp:{
    boxShadow: '0px 0px 30px rgb(209,209,209)',
    "-webkit-box-shadow": '0px 0px 30px rgb(209,209,209)',
    "-moz-box-shadow": '0px 0px 30px rgb(209,209,209)'
  },

  root:{
    fontSize:'1.2rem !important'
  },

  iconFilled:{
    color: '#fac400 !important',
  },

  iconHover:{
    color: '#fac400',
  },

  iconEmpty:{
    color: '#fac400 !important',
  },

  icon:{
    display:'unset !important'
  },

    reactPlayer:{
        width:'100% !important',
        height:'100% !important',
        borderTopLeftRadius:'5px',
        borderTopRightRadius:'5px',
        "& video":{
            width:'100% !important',
            height:'100% !important',
            objectFit:'cover',
            borderTopLeftRadius:'5px',
            borderTopRightRadius:'5px',
        },
        "& iframe":{
            borderTopLeftRadius:'8px',
            borderTopRightRadius:'8px',
        },

        '&.react-player__preview':{
            borderTopLeftRadius:'8px',
            borderTopRightRadius:'8px',
        }
    },
}));


const CourseCard = ({ service,displayDescription,productType, companyId }) => {
  const classes = useStyles();
  const { data } = useCompanyData();
  const { t, fontFamily, isRTL, mainColor, buttonColor, buttonFontColor } = data || {};
  const matches = useMediaQuery(theme.breakpoints.down('lg'));
  const { courseHandleClick, rating, reviews } = useServiceCard({service,productType,companyId});
  const maxStringLength = matches ? 80 : 130;

  const shortDescription = extractContent(service?.description);

  const fileType = determineFileType(service?.cover);

  return (
      (<Box
        onClick={courseHandleClick}
        style={{ cursor: 'pointer',borderRadius:'5px'}}
        width={{ xs: '175px', md: '175px' }}
        height={{xs: '181px', md: '181px'}}
        mx={1}
        my={2}
        dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
        className={classes.mainComp}
        bgcolor="#fff"
      >
          <Box width="100%" height="100px" position="relative">
              {fileType === 'video' ?
              <>
                  <ReactPlayer url={service.cover}
                  className={classes.reactPlayer} />
              </>
              :
              <ImgLazyLoad>
                  <img
                      style={{ width: '100%', height: '100%', objectFit: 'cover',borderTopLeftRadius:'8px', borderTopRightRadius:'8px' }}
                      src={service?.cover || NoImage}
                      alt={service?.name || 'course'}
                  />
              </ImgLazyLoad>
              }
          </Box>
          <Box height="79px" py={2} px={2}>
              <Typography gutterBottom variant="h6" style={{ fontWeight: 700,fontSize:'12px',textTransform:'capitalize' }}>
              {service.enName}
              </Typography>

              <Box 
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="space-between"
              >
                  <span style={{color:'#7A889B',fontSize:'8px'}}>Ahsan Mani</span>
                  
                  <IconButton style={{backgroundColor:'#F5F6F8',color:'#000'}} size="large">
                      <BookmarkBorder style={{fontSize:'1rem'}}/>
                  </IconButton>
              </Box>

              {/* { displayDescription ?
              <Box py={1} style={{height:'50px'}}>
              <Typography variant="body2" style={{ opacity: '0.7' }}>
                  {shortDescription?.substring(0, maxStringLength)}
                  {shortDescription  ? shortDescription?.length > maxStringLength && '...' : ''}
              </Typography>
              </Box>
              : null } */}

              {/* <Box textAlign="right" style={{display:'flex',flexDirection:'column',alignItems:'flex-end'}}>
                  <Button
                      onClick={courseHandleClick}
                      variant="text"
                      className={classes.readMore}
                      style={{backgroundColor: buttonColor ? buttonColor : 'inherit',color:buttonFontColor ? buttonFontColor : 'inherit'}}
                      endIcon={
                      isRTL === 'en' ? (
                          <ArrowForward
                          style={{ fontSize: '1.2rem', margin: '0 0.2em' }}
                          />
                      ) : (
                          <ArrowBack
                          style={{ fontSize: '1.2rem', margin: '0 0.2em' }}
                          />
                      )
                      }
                  >
                      {t && t('companyPage.readMore')}
                  </Button>
              </Box> */}
        </Box>
      </Box>)
  );
};

export default CourseCard;